module.exports = __webpack_public_path__ + "static/office_inside_view-0a39da2dd97038f779722e79d5ee9320.jpg";